// AXIOS
import axios from "axios";

import { apiUrl_forGoogleCategories } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get google categories
export let cancelGetGoogleShoppingCategoriesApi;
export async function getGoogleShoppingCategories(headers) {
    if(headers) {
        const data = await axios.get(
            apiUrl_forGoogleCategories + "googleshop/categories",
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetGoogleShoppingCategoriesApi = c;
                }),
            }
        );
    
        return data;
    }
}

// set google categories
export let cancelSetGoogleShoppingCategoriesApi;
export async function setGoogleShoppingCategories(
    headers,
    { category, breadcrumb, product_type }
) {
    if (headers && category && product_type) {
        const data = await axios.put(
            apiUrl_forGoogleCategories + "googleshop/categories",
            {
                google_shop_data: {
                    category,
                    breadcrumb,
                    product_type,
                },
            },
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelSetGoogleShoppingCategoriesApi = c;
                }),
            }
        );
        return data;
    }
}
// set google settings
export let cancelGetGoogleSettingsCategoriesApi;
export async function getGoogleShoppingSettings(headers) {
    if(headers) {
        const data = await axios.get(apiUrl_forGoogleCategories + "googleshop", {
            headers: { ...headers },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancelGetGoogleSettingsCategoriesApi = c;
            }),
        });
    
        return data;
    }
}
